export const getTimeFormate = (time: string, format?: { type: "12H" | "24H" }) => {
    if (!time) return time
    if (format?.type === "24H") {
        return time
    } else {
        // Default to 12-hour format
        const [hours, minutes] = time.split(":")
        const period = +hours >= 12 ? "PM" : "AM"
        const formattedHours = +hours % 12 || 12 // Convert to 12-hour format
        return `${formattedHours}:${minutes} ${period}`
    }
}
